export default "__VITE_ASSET__BjmyoGKS__"